import React, {createContext, ReactNode, useContext, useState} from 'react'

export const UIGameReplayContext = createContext({
    isReplay: false,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setIsReplay: (isReplay: boolean) => {},
})

export const useUIGameReplayContext = () => useContext(UIGameReplayContext)

interface UIGameReplayProviderProps {
    isReplay: boolean
    children: ReactNode
}

export const UIGameReplayProvider = ({
    isReplay: defaultIsReplay,
    children,
}: UIGameReplayProviderProps) => {
    const [isReplay, setIsReplay] = useState(defaultIsReplay)

    return <UIGameReplayContext.Provider value={{
        isReplay: isReplay,
        setIsReplay: setIsReplay,
    }}>
        {children}
    </UIGameReplayContext.Provider>
}
